import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

import { CommonService } from './common.service';
import { ErrorService } from './error.service';
import { DriverService } from './driver.service';

import { WorkDiary, EWDRecord } from './../models/workdiary';
import { RowState } from './../models/common.enum';

import * as moment from 'moment';

@Injectable()
export class WorkDiaryService {

    private url = CommonService.getEwdApiURL() + 'ewd';

    constructor(
      private http: Http,
      private errorService: ErrorService,
      private driverService: DriverService
    ) { }

    getWorkDiaryWithChart(
        dateStart: string,
        dateEnd: string,
        driverId: number,
        showBreach: boolean,
        ): Observable<WorkDiary> {
        const params: URLSearchParams = new URLSearchParams();
        params.set('startDateLocal', dateStart);
        params.set('endDateLocal', dateEnd);
        params.set('driverId', String(driverId));
        params.set('showBreach', showBreach + '');
        const queryString = params.toString();
        return this.http.get(this.url + '/WorkDiaryChart?' + queryString)
          .map((response: Response) => {
            const result = response.json();
            return result;
          })
          .catch(this.errorService.handleError);
      }

      getWorkDiaryWithTimeZone(
        dateStart: string,
        dateEnd: string,
        username: string
      ): Observable<WorkDiary> {
        const params: URLSearchParams = new URLSearchParams();
        params.set('startDate', dateStart);
        params.set('endDate', dateEnd);
        params.set('username', username);
        const queryString = params.toString();
        return this.http.get(this.url + '/WorkDiary?' + queryString)
          .map((response: Response) => {
            const result = response.json();
            return result;
          })
          .catch(this.errorService.handleError);
      }

    download(ewdRecords, startDate, endDate, driverId): Observable<any> {
      return this.http.post(this.url + '/GeneratePdf',
          {
            StartDateTime: startDate,
            EndDateTime: endDate,
            EWDRecords: ewdRecords,
            DriverId: driverId
          },
          {
            responseType: ResponseContentType.Blob
          }
        )
        .map((response: Response) => ({ blob : response.blob(), filename: response.headers.get('x-filename') }))
        .catch(this.errorService.handleError);
    }

    addWrittenWorkDiaryRecords(driverId, wwdSecurityNumber, wwdPageNumber, allWorkRestRecords, newAnnotationRecords, allTwoUpRecords, newNumberPlateRecords, localDate) {
      return this.http.post(this.url + '/AddWrittenWorkDiary',
                  {
                    DriverId: driverId,
                    WWDSecurityNumber: wwdSecurityNumber,
                    WWDPageNumber: wwdPageNumber,
                    AllWorkRestRecords: allWorkRestRecords,
                    NewAnnotationRecords: newAnnotationRecords,
                    AllTwoUpRecords: allTwoUpRecords,
                    NewNumberPlateRecords: newNumberPlateRecords,
                    LocalDate: localDate
                  })
        .map(
        (response: Response) => response.json()
        )
        .catch(this.errorService.handleError);
    }
}
